import React from "react";

const UnitsRequested = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="39"
      viewBox="0 0 38 39"
      fill="none"
    >
      <path
        d="M32.388 0H5.58367C2.45853 0 0 2.51719 0 5.72321V33.2219C0 36.428 2.45853 39 5.58367 39H32.388C35.5132 39 38 36.428 38 33.2219V5.72321C38 2.51719 35.5132 0 32.388 0ZM34.7736 33.2219C34.7736 34.5421 33.6748 35.6164 32.388 35.6164H5.58367C4.29687 35.6164 3.22642 34.5421 3.22642 33.2219V5.72321C3.22642 4.40308 4.29687 3.38356 5.58367 3.38356H32.388C33.6748 3.38356 34.7736 4.40308 34.7736 5.72321V33.2219Z"
        fill="#435CFF"
      />
      <path
        d="M28.3099 17H15.6901C14.7567 17 14 17.8836 14 19C14 20.1164 14.7565 21 15.6901 21H28.3099C29.2433 21 30 20.1164 30 19C30 17.8836 29.2433 17 28.3099 17Z"
        fill="#435CFF"
      />
      <path
        d="M28.3099 10H15.6901C14.7567 10 14 10.8836 14 12C14 13.1164 14.7565 14 15.6901 14H28.3099C29.2433 14 30 13.1164 30 12C30 10.8836 29.2433 10 28.3099 10Z"
        fill="#435CFF"
      />
      <path
        d="M28.3099 24H15.6901C14.7567 24 14 24.8836 14 26C14 27.1164 14.7565 28 15.6901 28H28.3099C29.2433 28 30 27.1164 30 26C30 24.8836 29.2433 24 28.3099 24Z"
        fill="#435CFF"
      />
      <path
        d="M10 28C11.1046 28 12 27.1046 12 26C12 24.8954 11.1046 24 10 24C8.89543 24 8 24.8954 8 26C8 27.1046 8.89543 28 10 28Z"
        fill="#435CFF"
      />
      <path
        d="M10 21C11.1046 21 12 20.1046 12 19C12 17.8954 11.1046 17 10 17C8.89543 17 8 17.8954 8 19C8 20.1046 8.89543 21 10 21Z"
        fill="#435CFF"
      />
      <path
        d="M10 14C11.1046 14 12 13.1046 12 12C12 10.8954 11.1046 10 10 10C8.89543 10 8 10.8954 8 12C8 13.1046 8.89543 14 10 14Z"
        fill="#435CFF"
      />
    </svg>
  );
};

export default UnitsRequested;
